import {Route} from "react-router-dom";

import {CoordinationindexesViewPanel} from "app/coordinationindexes/CoordinationindexesViewPanel";
import {ZoningareasViewPanel} from "app/zoningareas/ZoningareasViewPanel";
import {EezViewPanel} from "app/eez/EezViewPanel";
import {MapViewerPage} from "../container/MapViewerPage";

export const mapViewerRoutes = [
    <Route key="home-map-page" path="" element={<MapViewerPage />}>
        {/* <Route
            key="home-map-page-basemap-info"
            path="info/basemap/:id"
            element={<BasemapViewPanel />}
        /> */}
        <Route
            key="home-map-page-coordationindexes-info"
            path="info/coordinationindexes/:id"
            element={<CoordinationindexesViewPanel />}
        />
        <Route
            key="home-map-page-eez-info"
            path="info/eez/:id"
            element={<EezViewPanel />}
        />
        {/*
        <Route
            key="home-map-page-mspeezfitness-info"
            path="info/mspeezfitness/:id"
            element={<ViewMspeezfitnessPanel />}
        />
        <Route
            key="home-map-page-nm12-info"
            path="info/nm12/:id"
            element={<ViewNm12Panel />}
        /> */}
        <Route
            key="home-map-page-zoningareas-info"
            path="info/zoningareas/:id"
            element={<ZoningareasViewPanel />}
        />
    </Route>,
];
